module.exports = __webpack_public_path__ + "img/sheda.6ada357e.png";